<template>
  <div class="page">
    <div class="page-content">
      <div class="layoutTop"/>
      <div class="container-fluid">

        <b-card class=" panel21">
          <b-tabs content-class="mt-3" fill align="center" active-nav-item-class="font-weight-bold">

            <!-- GRAPH BY STATUS -->
            <!-- <b-tab :title="$i18n.t('graph.statistics_by_status')" active>
              <b-card-text class="borderRounded">
                <graph-panel
                  :graphTitle="$i18n.t('graph.statistics_by_status')"
                  :periodes="['lastDay', 'lastWeek', 'lastMonth', 'lastYear']"
                  @fetch-periode="fetchGraphStatus($event)"
                  @filter-graph="filterStatus($event)"
                  @clear-filter="clearFilterStatus()"
                  :ibans="ibans"
                  :contacts="contacts"
                  :documentTypes="docTypes"
                  :trueValueLabel="$i18n.t('graph.shw_amnt')"
                  :falseValueLabel="$i18n.t('graph.shw_nmbr')"
                  v-model="showingStatus">
                  <graph-by-status
                    :showAmountNotNumber="showingStatus"
                    :chartData="statusGraph">
                  </graph-by-status>
                </graph-panel>
              </b-card-text>
            </b-tab> -->

            <!-- GRAPH BY STATUS FOR DOCUMENTS -->
            <!-- <b-tab :title="$i18n.t('graph.statistics_by_status')"active>
              <b-card-text class="borderRounded">
                <graph-panel
                  :graphTitle="$i18n.t('graph.snt_and_rcvd_docs')"
                  :periodes="['lastDay', 'lastWeek', 'lastMonth', 'lastYear']"
                  @fetch-periode="fetchGraphStatus($event)"
                  @filter-graph="filterStatus($event)"
                  @clear-filter="clearFilterStatus()"
                  :ibans="ibans"
                  :contacts="contacts"
                  :documentTypes="docTypes"
                  :trueValueLabel="$i18n.t('graph.shw_amnt')"
                  :falseValueLabel="$i18n.t('graph.shw_nmbr')"
                  v-model="showingStatus"
                >
                  <graph-by-document-status :showAmountNotNumber="showingStatus"
                                   :chartData="statusGraph"
                  ></graph-by-document-status>
                </graph-panel>
              </b-card-text>
            </b-tab> -->

            <!-- GRAPH BY BALANCE -->
            <!-- <b-tab :title="$i18n.t('graph.statistics_by_blnc')" disabled>
              <b-card-text class="borderRounded">
                <graph-panel
                  :graphTitle="$i18n.t('graph.snt_and_rcvd_trnsctns')"
                  :periodes="['lastDay', 'lastWeek', 'lastMonth', 'lastYear']"
                  @fetch-periode="fetchGraphBalance($event)"
                  @filter-graph="filterBalance($event)"
                  @clear-filter="clearFilterBalance()"
                  :ibans="ibans"
                  :contacts="contacts"
                  :trueValueLabel="$i18n.t('graph.shw_trnsctns')"
                  :falseValueLabel="$i18n.t('graph.shw_trsry')"
                  v-model="showingBalance"
                >
                  <graph-by-balance :showTransactionsNotTreasury="showingBalance"></graph-by-balance>
                </graph-panel>
              </b-card-text>
            </b-tab> -->

            <!-- GRAPH BY CONTACT CREDITOR -->
            <!-- <b-tab :title="$i18n.t('graph.statistics_by_crdtrs')" disabled>
              <b-card-text class="borderRounded">
                <graph-panel
                  :graphTitle="$i18n.t('graph.crdtrs_snt_trnsctns')"
                  :periodes="['lastDay', 'lastWeek', 'lastMonth', 'lastYear']"
                  @fetch-periode="fetchGraphContact($event)"
                  @filter-graph="filterContact($event)"
                  @clear-filter="clearFilterContact()"
                  :ibans="ibans"
                  :contacts="contacts"
                  :trueValueLabel="$i18n.t('graph.shw_amnt')"
                  :falseValueLabel="$i18n.t('graph.shw_nmbr')"
                  v-model="showingContact"
                >
                  <graph-by-contact :showSentNotReceived="true" :showAmountNotNumber="showingContact"></graph-by-contact>
                </graph-panel>
              </b-card-text>
            </b-tab> -->

            <!-- GRAPH BY CONTACT DEBTOR -->
            <!-- <b-tab :title="$i18n.t('graph.statistics_by_dbtrs')" disabled>
              <b-card-text class="borderRounded">
                <graph-panel
                  :graphTitle="$i18n.t('graph.dbtrs_rcvd_trnsctns')"
                  :periodes="['lastDay', 'lastWeek', 'lastMonth', 'lastYear']"
                  @fetch-periode="fetchGraphContact($event)"
                  @filter-graph="filterContact($event)"
                  @clear-filter="clearFilterContact()"
                  :ibans="ibans"
                  :contacts="contacts"
                  :trueValueLabel="$i18n.t('graph.shw_amnt')"
                  :falseValueLabel="$i18n.t('graph.shw_nmbr')"
                  v-model="showingContact"
                >
                  <graph-by-contact :showSentNotReceived="false" :showAmountNotNumber="showingContact"></graph-by-contact>
                </graph-panel>
              </b-card-text>
            </b-tab> -->

            <!-- Statistiques CashFlow et Prévisions -->
            <b-tab :title="$t('monitoring.cashflow.title')" lazy>
              <CashStats />
            </b-tab>
            <!-- Statistiques MarketPlace Paiement -->
            <b-tab :title="$t('monitoring.mp.title')" lazy v-if="!demo">
              <MPstats />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import graphByStatus from '@/pages/statistics/components/GraphByStatus.vue'
import graphByDocumentStatus from '@/pages/statistics/components/GraphByDocumentStatus.vue'
import graphByBalance from '@/pages/statistics/components/GraphByBalance.vue'
import graphByContact from '@/pages/statistics/components/GraphByContact.vue'
import graphPanel from '@/pages/statistics/components/GraphPanel.vue'
import documentSerialize from '@/helpers/documentSerialize.json'
import MPstats from '@/pages/statistics/components/MarketPlace/MPstats.vue'
import CashStats from '@/pages/statistics/components/CashFlow/CashStats.vue'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'graph-by-status': graphByStatus,
    'graph-by-document-status': graphByDocumentStatus,
    'graph-by-balance': graphByBalance,
    'graph-by-contact': graphByContact,
    'graph-panel': graphPanel,
    MPstats,
    CashStats
  },
  data () {
    return {
      demo: true,
      amount: true,
      pStatus: 'month',
      ibanStatus: [],
      contactStatus: [],
      ibans: [],
      contacts: [],
      docTypes: [],
      showingStatus: true,
      showingBalance: true,
      showingContact: true,
      statusGraph: undefined,
      serviceId: '6'
    }
  },
  created () {
    // this.$engine.monitoring.initAllGraphs('month')
    this.ibans = this.$engine.bankAccounts.get().map(entry => ({name: entry.name, iban: entry.iban}))
    this.contacts = this.$engine.contacts.get().map(entry => ({id: entry.identifier, alias: entry.label}))
    let keys = Object.keys(documentSerialize)
    for (var i = 0; i < keys.length; i++) {
      if (!documentSerialize[keys[i]].disabled) {
        this.docTypes.push({'id': keys[i], 'label': this.$t(documentSerialize[keys[i]].label)})
      }
    }

    let dates = this.$engine.monitoring.getDatesFromPeriode('month')
    this.$engine.monitoring.fetchPromise({
      'service': this.serviceId,
      'dateBegin': dates.begin,
      'dateEnd': dates.end,
      'getDate': 0,
      'getIban': 1,
      'getContact': 1
    }).then(resp => {
      this.$engine.monitoring.rawByStatus = resp.data
      // console.log(this.docStatusToGraphStatus(resp.data))
      // const filteredData = this.$engine.monitoring.applyFilterOnData(this.docStatusToGraphStatus(resp.data), this.$engine.monitoring.filterGraphStatus)
      this.$engine.monitoring.graphByStatus = this.$engine.monitoring.makeGraphByStatus(resp.data, this.serviceId)
      this.statusGraph = this.$engine.monitoring.graphByStatus
    })
  },
  methods: {
    // Fetch Methods
    fetchGraphStatus (periode) {
      this.$engine.monitoring.fetchGraphByStatus(periode).then(resp => {
        this.statusGraph = resp
      })
    },
    fetchGraphBalance (periode) {
      this.$engine.monitoring.fetchGraphByBalance(periode)
    },
    fetchGraphContact (periode) {
      this.$engine.monitoring.fetchGraphByContact(periode)
    },

    // Transform Methods
    docStatusToGraphStatus (docStatus) {
      docStatus['creditor'] = {}
      docStatus['0'].forEach((item, i) => {
        docStatus['creditor']['Doc_' + item.status] = {'amount': item.number}
      })
      delete docStatus['0']

      docStatus['debtor'] = {}
      docStatus['1'].forEach((item, i) => {
        docStatus['debtor']['Doc_' + item.status] = {'amount': item.number}
      })
      delete docStatus['1']
      return docStatus
    },

    // Filter Methods
    filterStatus ({period = 'lastMonth', ibans, contacts, docTypes}) {
      this.statusGraph = undefined
      let filter = []
      docTypes.forEach((item, i) => {
        filter.push({'type': item})
      })
      if (filter.length === 0) {
        filter = undefined
      }
      let dates = this.$engine.monitoring.getDatesFromPeriode(period)
      let that = this
      this.$engine.monitoring.fetchPromise({
        'service': this.serviceId,
        'contact': contacts,
        'dateBegin': dates.begin,
        'dateEnd': dates.end,
        'getDate': 1,
        'getIban': 1,
        'getContact': 1,
        'types': filter
      })
      .then(resp => {
        if (resp.status === 200) {
          // that.$engine.monitoring.graphByStatus = that.docStatusToGraphStatus(resp.data)
          that.$engine.monitoring.graphByStatus = this.$engine.monitoring.makeGraphByStatus(resp.data, that.serviceId)
          that.statusGraph = that.$engine.monitoring.graphByStatus
        }
      })
      // this.statusGraph = this.$engine.monitoring.filterForGraphStatus(this.docTypes, this.docTypes)
    },
    filterBalance ({ibans, contacts}) {
      this.$engine.monitoring.filterForGraphBalance(ibans, contacts)
    },
    filterContact ({ibans, contacts}) {
      this.statusGraph = this.$engine.monitoring.filterForGraphContact(ibans, contacts)
    },
    // Clear Methods
    clearFilterStatus () {
      this.ibanStatus = []
      this.contactStatus = []
      this.statusGraph = this.$engine.monitoring.clearFilterForGraphStatus()
    },
    clearFilterBalance () {
      this.$engine.monitoring.clearFilterForGraphBalance()
    },
    clearFilterContact () {
      this.$engine.monitoring.clearFilterForGraphContact()
    }
  }
}
</script>

<style lang="css" scoped>
.borderRounded {
  border-radius:10px;
}
.separator {
  border-bottom: 1px solid silver;
  margin-top: 40px;
  margin-bottom: 40px;
}

.spacer {
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// StatisticsPage.vue?a5ec3b20